import Vue from 'vue';
import App from './App.vue';

// import VueGtm from 'vue-gtm';
import router from './router';
import store from './store';
import VueHead from 'vue-head';
import smoothscroll from 'smoothscroll-polyfill';



Vue.config.productionTip = false

// Vue.use(VueGtm, {
//   id: 'GTM-KMXXC6H',//your
// });

Vue.use(VueHead, {
  separator: '',
  complement: '',
})

smoothscroll.polyfill();

new Vue({
  router: router,
  store: store,
  render: h => h(App),
}).$mount('#app')


